module.exports = __webpack_public_path__ + "img/diagnostic1.09c1332f.jpg";